/* HB — Retire les anciens filtres invisibles des liens de collections. */
(() => {
  if (!location.pathname.split('/').includes('collections')) return;
  if (window.__hbSimpleCollectionFilters) return;
  window.__hbSimpleCollectionFilters = true;
  const url = new URL(location.href);
  // Tags remain reserved for the existing Coup de cœur mode.
  const supported = new Set(['filter.v.availability', 'filter.p.m.custom.licence', 'filter.p.m.custom.licences', 'filter.p.m.custom.type_manga', 'filter.p.m.custom.genres_manga', 'filter.p.tag']);
  let changed = false;
  for (const key of [...url.searchParams.keys()]) {
    if (key.startsWith('filter.') && !supported.has(key)) {
      url.searchParams.delete(key);
      changed = true;
    }
  }
  if (!changed) return;
  for (const key of [...url.searchParams.keys()]) {
    if (key === 'page' || key.startsWith('page_')) url.searchParams.delete(key);
  }
  // Keep view, preview_theme_id, sort, locale and hash, without another history entry.
  location.replace(url.href);
})();
